if (document.querySelector('.ctabox__carousel') && document.querySelector('.ctabox__carousel').getAttribute('data-count-slides') > 1) {
    const $classHero = 'ctabox';
    const swiperPaneCarousel1 = new Swiper(`.${$classHero}__carousel`, {
        wrapperClass: `${$classHero}__ribbon`,
        slideClass: `${$classHero}__pane`,
        direction: 'horizontal',
        loop: true,
        speed: 600,
        navigation: {
            prevEl: `.${$classHero}__controller--left`,
            nextEl: `.${$classHero}__controller--right`,
        },
        allowTouchMove: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
    });

    // ====

    const conindBlock1 = document.querySelector(`.${$classHero}__block`);
    const slideCount1 = swiperPaneCarousel1.slides.length;
    const blockWidthPercentage1 = 100 / slideCount1;

    // Set initial size and position
    conindBlock1.style.width = `${blockWidthPercentage1}%`;
    updateBlockPosition();

    // Update position on slide change
    swiperPaneCarousel1.on('slideChange', updateBlockPosition);

    function updateBlockPosition() {
        const activeIndex = swiperPaneCarousel1.realIndex;
        conindBlock1.style.left = `${blockWidthPercentage1 * activeIndex}%`;
    }
}